import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { api } from '../lib/api';

const BuyerAuthContext = createContext(null);

export function BuyerAuthProvider({ children }) {
  const [buyer, setBuyer] = useState(null);   // { name, company, personal_note, product_notes }
  const [checking, setChecking] = useState(true);

  const refresh = async () => {
    const token = localStorage.getItem('buyer_token');
    if (!token) { setBuyer(null); setChecking(false); return; }
    try {
      const { data } = await api.get('/auth/buyer-profile', { headers: { Authorization: `Bearer ${token}` } });
      setBuyer(data.is_buyer ? data : null);
    } catch {
      localStorage.removeItem('buyer_token');
      setBuyer(null);
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    if (data.user.role !== 'buyer') {
      throw new Error('Not a buyer account');
    }
    localStorage.setItem('buyer_token', data.token);
    await refresh();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('buyer_token');
    setBuyer(null);
  };

  const value = useMemo(() => ({ buyer, login, logout, checking, refresh }), [buyer, checking]);

  return (
    <BuyerAuthContext.Provider value={value}>
      {children}
    </BuyerAuthContext.Provider>
  );
}

export const useBuyer = () => useContext(BuyerAuthContext);
